import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton, Tooltip } from "@material-ui/core";
import { FileCopy, Delete } from "@material-ui/icons";
import { useNodeActions } from "../context/NodeActionsContext";

const useStyles = makeStyles(() => ({
  wrapper: {
    position: "relative",
    display: "inline-block",
  },
  toolbar: {
    position: "absolute",
    top: -6,
    right: -6,
    zIndex: 100,
    display: "flex",
    gap: 2,
    background: "rgba(255,255,255,0.97)",
    borderRadius: 6,
    boxShadow: "0 2px 10px rgba(0,0,0,0.24)",
    padding: "2px 3px",
    border: "1px solid rgba(0,0,0,0.07)",
    pointerEvents: "all",
  },
  copyBtn: {
    padding: 3,
    color: "#5c35d4",
    "&:hover": { background: "rgba(92,53,212,0.12)" },
  },
  deleteBtn: {
    padding: 3,
    color: "#e53935",
    "&:hover": { background: "rgba(229,57,53,0.12)" },
  },
}));

const withNodeActions = (NodeComponent, nodeTypeName) => {
  const WrappedNode = ({ id, data, selected, ...rest }) => {
    const classes = useStyles();
    const { onDeleteNode, onDuplicateNode } = useNodeActions();
    const [hovered, setHovered] = useState(false);
    const showToolbar = selected || hovered;
    const isStart = nodeTypeName === "start";

    return (
      <div
        className={classes.wrapper}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <NodeComponent id={id} data={data} selected={selected} {...rest} />

        {showToolbar && (
          <div className={classes.toolbar}>
            <Tooltip title="Duplicar" placement="top" arrow>
              <IconButton
                size="small"
                className={classes.copyBtn}
                onClick={(e) => {
                  e.stopPropagation();
                  e.nativeEvent && e.nativeEvent.stopImmediatePropagation();
                  onDuplicateNode(id);
                }}
              >
                <FileCopy style={{ fontSize: 13 }} />
              </IconButton>
            </Tooltip>

            {!isStart && (
              <Tooltip title="Eliminar" placement="top" arrow>
                <IconButton
                  size="small"
                  className={classes.deleteBtn}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.nativeEvent && e.nativeEvent.stopImmediatePropagation();
                    onDeleteNode(id);
                  }}
                >
                  <Delete style={{ fontSize: 13 }} />
                </IconButton>
              </Tooltip>
            )}
          </div>
        )}
      </div>
    );
  };

  WrappedNode.displayName = `withNodeActions(${
    NodeComponent.displayName || NodeComponent.name || "Node"
  })`;
  return WrappedNode;
};

export default withNodeActions;
